import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21e58053"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = {
  key: 0,
  class: "section"
}
const _hoisted_6 = { class: "section-title" }
const _hoisted_7 = {
  key: 2,
  class: "form-item-agreement"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" E-mail 및 SMS 마케팅 정보 수신동의 (선택) ")

import { reactive, ref, watchEffect } from 'vue';
  import { FormItem } from '@/types/form';
  import { ColorVariants } from '@/constants';
  import { useI18n } from 'vue-i18n';
  import { useToast } from 'bootstrap-vue-3';
  import { useRoute } from 'vue-router';
  import _ from 'lodash';
  import AdditionalInformationForm from './additional-information-form.vue';
  import ContactInformationForm from './contact-information-form.vue';
  import AgreeForm from './agree-form.vue';
  import { Validator, alert } from '@/utils';
  import { authStore } from '@/stores';

  
export default /*#__PURE__*/_defineComponent({
  emits: ['submit'],
  setup(__props, { emit: emits }) {

  const { t, locale } = useI18n();

  const route = useRoute();
  const isSignup = route.name === 'signup';
  const agreeSubscribe = ref(false);
  watchEffect(() => {
    if (locale.value === 'ko') {
      agreeSubscribe.value = authStore.user?.subscribe_tc_information || false;
    }
  });

  const toast = useToast();
  
  const accountInformationFormItems = reactive<FormItem[]>([
    {
      label: t('EMAIL ADDRESS'),
      type: 'input',
      inputType: 'email',
      key: 'email',
      required: true,
      placeholder: 'address@domain.com'
    },
    {
      label: t('PASSWORD'),
      type: 'input',
      inputType: 'password',
      key: 'password',
      required: true,
      placeholder: '',
      triggerPwd: true
    },
    {
      label: t('CONFIRM PASSWORD'),
      type: 'input',
      inputType: 'password',
      key: 'password_confirmation',
      required: true,
      placeholder: '',
      triggerPwd: true
    }
  ]);

  function formatFormData(formData: FormData) {
    const data: { [key: string]: any } = {};
    for (let [key, val] of formData.entries()) {
      if (data[key]) {
        data[key] = [val].concat(data[key]);
      } else {
        data[key] = val;
      }
    }
    const baseKey = [
      'email',
      'phone_number',
      'verification_code',
      'password',
      'password_confirmation',
      'subscribe_tc_information',
      'signup_condictions',
      'country_code',
    ];
    const profileAttributesKey = [
      'gender',
      'first_name',
      'last_name',
      'nick_name',
      'age',
      'street_address',
      'extended_address',
      'locality',
      'region',
      'postal_code',
      'organization_name',
      'organization_type',
      'people_collection',
      'source_channel',
    ];
    return {
      ..._.pick(data, baseKey),
      profile_attributes: _.pick(data, profileAttributesKey),
    };
  }

  function handleSubmit(event: any) {
    const body: { [key: string]: any } = formatFormData(new FormData(event.target));
    if (body.phone_number) {
      const isValid = Validator.isPhoneNumberValid(body.phone_number as string);
      if (!isValid) {
        alert({ title: t('phoneNumberIsInValid') });
        return;
      }
    }

    // 手机号使用带dialCode的完整手机号
    if (_.has(body, 'phone_number')) {
      body.phone_number = `+${body.country_code} ${body.phone_number}`;
    }
    if (body.password !== body.password_confirmation) {
      toast.show({ body: t('Inconsistent password input') }, { variant: 'warning' });
      return;
    }
    if (locale.value === 'ko') {
      body.subscribe_tc_information = body.subscribe_tc_information === 'true';
    }
    delete body.country_code;
    emits('submit', body);
  }

return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createBlock(_component_b_form, {
    class: _normalizeClass(["signup-component", { edit: !isSignup }]),
    onSubmit: handleSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)('Contact information')), 1),
        _createVNode(ContactInformationForm)
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)('Additional information')), 1),
        _createVNode(AdditionalInformationForm)
      ]),
      isSignup
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(t)('Account information')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountInformationFormItems), (item) => {
              return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
                key: item.key,
                config: item,
                form: {}
              }, null, 8, ["config"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      isSignup
        ? (_openBlock(), _createBlock(AgreeForm, { key: 1 }))
        : (_unref(locale) === 'ko')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_b_form_checkbox, {
                modelValue: agreeSubscribe.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agreeSubscribe).value = $event)),
                value: true,
                name: "subscribe_tc_information"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
      _createVNode(_component_b_button, {
        type: "submit",
        pill: "",
        variant: _unref(ColorVariants).primary,
        class: "btn-submit"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isSignup ? _unref(t)('Sign Up') : _unref(t)('Save')), 1)
        ]),
        _: 1
      }, 8, ["variant"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})